import { useContext, useEffect, useState } from 'react'
import { AlertContext } from 'context/alertContext'

interface Props {
  className?: string
}

const Alert: React.FC<Props> = () => {
  const { showMessage } = useContext(AlertContext)
  const [show, setShow] = useState(false)
  const [message, setMessage] = useState('')
  const [type, setType] = useState('Success')
  const [background, setBackground] = useState<
    'bg-green' | 'bg-red' | 'bg-yellow-500' | 'bg-blue'
  >('bg-green')
  const [textColor, setTextColor] = useState<'text-white' | 'text-black'>(
    'text-white'
  )

  useEffect(() => {
    setShow(showMessage.show)
    setMessage(showMessage.message)
    setType(showMessage.type)
  }, [showMessage])

  useEffect(() => {
    switch (type) {
      case 'Success':
        setBackground('bg-green')
        setTextColor('text-white')
        break
      case 'Error':
        setBackground('bg-red')
        setTextColor('text-white')
        break
      case 'Warning':
        setBackground('bg-yellow-500')
        setTextColor('text-black')
        break
      case 'Info':
        setBackground('bg-blue')
        setTextColor('text-white')
        break
      default:
        setBackground('bg-green')
        setTextColor('text-white')
        break
    }
  }, [type])

  if (!show) {
    return null
  }

  return (
    <div
      className={`
        ${background} ${textColor} left-1/2 -translate-x-1/2 fixed msm:bottom-[70px] bottom-3 z-50 w-full max-w-2xl mx-auto p-4 overflow-visible px-8 py-3 rounded
      `}
      role="alert"
    >
      <strong className="block sm:inline font-bold mr-4">{message}</strong>
      <button
        className="absolute top-0 bottom-0 right-0 pl-3 pr-1 pb-[2.5rem] pt-1"
        onClick={() => setShow(false)}
      >
        <svg
          className={`h-6 w-6 ${textColor}`}
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M6 18L18 6M6 6l12 12"
          />
        </svg>
      </button>
    </div>
  )
}

export default Alert
